export default __webpack_public_path__ + "static/media/logoMaccaferri.700e826c.png";